import {ApiAddress} from '../../../../types/checkoutApp.types';
import {GeoCodeModel} from './GeoCode.model';
import {StreetAddressModel} from './StreetAddress.model';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {isAddressWithGeoCode} from '../../../utils/types.util';

export class AddressModel {
  public streetAddress?: StreetAddressModel;
  public addressLine?: string;
  public addressLine2?: string;
  public city?: string;
  public postalCode?: string;
  public country?: string;
  public subdivision?: string;
  public countryFullname?: string;
  public subdivisionFullname?: string;
  public geocode?: GeoCodeModel;

  constructor(params: AddressModel) {
    this.streetAddress = params.streetAddress;
    this.addressLine = params.addressLine;
    this.addressLine2 = params.addressLine2;
    this.city = params.city;
    this.postalCode = params.postalCode;
    this.countryFullname = params.countryFullname;
    this.subdivisionFullname = params.subdivisionFullname;
    this.country = params.country;
    this.subdivision = params.subdivision;
    this.geocode = params.geocode;
  }

  public static fromCheckoutV1(address?: ApiAddress | null) {
    if (!address) {
      return undefined;
    }
    return new AddressModel({
      streetAddress: StreetAddressModel.fromCheckoutV1(address.streetAddress),
      addressLine: mapNullToUndefined(address.addressLine),
      addressLine2: mapNullToUndefined(address.addressLine2),
      city: mapNullToUndefined(address.city),
      postalCode: mapNullToUndefined(address.postalCode),
      countryFullname: mapNullToUndefined(address.countryFullname),
      subdivisionFullname: mapNullToUndefined(address.subdivisionFullname),
      country: mapNullToUndefined(address.country),
      subdivision: mapNullToUndefined(address.subdivision),
      geocode: isAddressWithGeoCode(address) ? GeoCodeModel.fromCheckoutV1(address.geocode) : undefined,
    });
  }
}
